import $ from 'jquery';
// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const swiperSlider = new Swiper('.swiper-slider', {
    modules: [Autoplay, Pagination],
    loop: true,
    slidesPerView: 1,
    autoplay: {
        delay: 5000
    },
    spaceBetween: 0,
    pagination: {
        el: '.swiper-pagination.swiper-pagination--slider',
        clickable: true,
    },
});

const swiper = new Swiper('.swiper-videos', {
    modules: [Autoplay, Pagination],
    loop: true,
    
    autoplay: {
        delay: 3000,
    },
    spaceBetween: 16,
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
    },

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});

const swiperGuides = new Swiper('.swiper-guides', {
    modules: [Navigation],
    loop: false,
    spaceBetween: 16,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    watchOverflow: true, 
    navigation: {
        nextEl: '.swiper-button-next.swiper-button-next--guides',
        prevEl: '.swiper-button-prev.swiper-button-prev--guides',
    },
});



/***********************************
 * HEADER
 ********************************* */

$('.m-toggle').on('click', function () {

    $(this).toggleClass('js-active');
    $('.menu').toggleClass('js-active');
    $('body').toggleClass('js-menu');

});

$(document).ready(function () {

    $('.item-submenu').on('click', function (e) {
        e.preventDefault();

        const submenuId = $(this).data('submenu');
        const $targetSubmenu = $('.submenu[data-menu="' + submenuId + '"]');
        const $header = $('.header');

        if ($targetSubmenu.is(':visible')) {

            $targetSubmenu.slideUp(300);
            $header.removeClass('js-submenu-active');
            $(this).removeClass('is-active');

        } else {

            $('.submenu').slideUp(300);
            $('.item-submenu').removeClass('is-active');

            $targetSubmenu.stop(true, true).slideDown(300);

            $header.addClass('js-submenu-active');
            $(this).addClass('is-active');
        }
    });

    $(document).on('click', function (e) {

        if (
            !$(e.target).closest('.item-submenu').length &&
            !$(e.target).closest('.submenu').length
        ) {
            $('.submenu').slideUp(300);
            $('.header').removeClass('js-submenu-active');
            $('.item-submenu').removeClass('is-active');
        }

    });

});
